import $ from 'jquery';
import { basketAdd } from "../queries";
import { updatePrices } from "../utilities";

$(document).on('prices-updated', function () {
    const $component = $('.catalog-detail-info__content');
    const $componentAvailable = $('.catalog-detail-info--available');

    if ($component.find('.ui-value--product-price').attr('data-price')) {
        $component.css({ display: 'flex' });
        $componentAvailable.show();
    } else {
        $(window).resize(function (){
            const windowsize = $(window).width();
            if (windowsize > 768) {
                $('.catalog-detail-info--notavailable').css({ display: 'flex' });
            }else if (windowsize < 768) {
                $('.catalog-detail-info--notavailable-mobile').css({ display: 'flex' });
            }
        });

        $(window).trigger('resize');

    }
});


$(document).on('change', '.ui-product-quantity', function (e, quantity) {
    if (+quantity < 1) {
        $('.catalog-detail-info').removeClass('catalog-detail-info--basket');
    }
});

$(document).on('click', '.catalog-detail-info__buy', async function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $component = $(this).parents('.catalog-detail-info');
    const productId = +$(this).attr('data-id');

    $component.addClass('catalog-detail-info--basket')
        .find('.ui-product-quantity').trigger('change', 1);

    const response = await basketAdd(productId);

    $('.header-basket').replaceWith(response.component);
    updatePrices();

    $('.header-basket').addClass('header-basket--opened');
    setTimeout(() => {
        if (!$('.header-basket').hasClass('header-basket--hovered')) {
            $('.header-basket').removeClass('header-basket--opened');
        }
    }, 2000);
});
